import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=02c1b13e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=02c1b13e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c1b13e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c1b13e')) {
      api.createRecord('02c1b13e', component.options)
    } else {
      api.reload('02c1b13e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=02c1b13e&scoped=true", function () {
      api.rerender('02c1b13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/instantDiscount/detail.vue"
export default component.exports